<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    v-cloak
    class="d-flex  align-center justify-center flex-column"
    style="height: 100%;position: relative"
  >
    <div
      style="width: 70%;max-width: 480px;"
    >
      <template v-if="!isLoading">
        <o-t-p-keyboard
          :extra-hint="$t('keyboardHint')"
          :title="title"
          @submit="checkPassword"
        />
        <div class="d-flex justify-center align-center mt-2">
          <a @click="changeBaseProduct">
            {{ $t('SelectOtherProductOption') }}
          </a>
        </div>
      </template>
      <template v-else>
        <div class="d-flex justify-center align-center flex-column">
          <div class="mb-10 text-h3 font-weight-bold">
            {{ $t('waitAMoment') }}
          </div>
          <v-progress-circular
            indeterminate
            size="64"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import OTPKeyboard from '@/views/widget/PINInput/OTPKeyboard.vue'
import { createCheckoutSession } from 'firestore-stripe-payments-jhd'
import { StripePayment } from '@/model/firebase/google-fire-base'
import i18n from '@/i18n'

export default {
  name: 'OldMemberPage',
  components: {
    OTPKeyboard
  },
  data () {
    return {
      isLoading: false,
      title: this.$i18n.t('keyboardHintCode'),
      realCouponCode: '961213',
      version: require('../../../package.json').version,
      userCurrentPinCode: null
    }
  },
  mounted () {
  },
  methods: {
    changeBaseProduct () {
      this.$router.push('/firstSubscription')
    },
    async checkPassword (code) {
      console.log(code)
      if (code === this.realCouponCode) {
        this.isLoading = true
        const session = await createCheckoutSession(StripePayment, {
          line_items: [
            {
              price: 'price_1MevtKInWSuIJQANIgaTh3mj',
              quantity: 1
            }
          ],
          payment_method_types: ['card', 'sepa_debit'],
          allow_promotion_codes: true

        }, { timeoutMillis: 60 * 1000 })
        window.location.assign(session.url)
        this.isLoading = false
      } else {
        this.title = i18n.t('OldMembersDiscountCode')
      }
    }
  }
}
</script>

<style scoped>

</style>
